import script from "./email-templates-configuration-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./email-templates-configuration-modal.vue?vue&type=script&setup=true&lang=ts"

import "./email-templates-configuration-modal.vue?vue&type=style&index=0&id=8c67121a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c67121a"]])

export default __exports__